module.exports = __webpack_public_path__ + "img/SL-M-260-300.fb5ca951.svg";